module.exports = __webpack_public_path__ + "img/toBack.1ca3e06c.png";